<template>
    <el-button :size="size" type="success" @click="handleClick">
        复制单据
    </el-button>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'LyButtonCopy',
        props: {
            infoid: [String, Number],
            size: {
                type: String,
                default: 'small'
            }
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        methods: {
            ...mapActions('bill', [
                'setCopyInfo'
            ]),
            /**
             * 按钮点击的监听
             */
            handleClick () {
                this.setCopyInfo({
                    id: this.infoid,
                    path: this.currRoute.path
                })
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
                this.$router.push({path: '/' + this.currRoute.type + '/' + this.currRoute.path + '/add'})
            }
        }
    }
</script>